var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    color: "white",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5222 10.7714L19.4785 4H18.0671L12.8952 9.87954L8.76437 4H4L10.2466 12.8909L4 19.9918H5.41155L10.8732 13.7828L15.2356 19.9918H20L13.5218 10.7714H13.5222ZM11.5889 12.9692L10.956 12.0839L5.92015 5.03921H8.0882L12.1522 10.7245L12.7851 11.6098L18.0677 18.9998H15.8997L11.5889 12.9696V12.9692Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.cbaf4484abf9957af660a23e1a46d6b1.svg";